import React from 'react';
import {
  MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardDateTimePicker, DatePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import styles from './styles';

const getComponent = ({ dateWithoutKeyboard, isDateTime }) => {
  if (dateWithoutKeyboard) return DatePicker;
  if (isDateTime) return KeyboardDateTimePicker;
  return KeyboardDatePicker;
};

const PF2MDatepickerNew = ({
  field,
  form,
  isDateTime,
  format,
  dateWithoutKeyboard,
  dateFuture = true,
  isFormControlled = true,
  onChange = () => { },
  value,
  error,
  helperText,
  classes,
  ...other
}) => {
  const { t: translate } = useTranslation();
  const currentError = isFormControlled ? form?.errors[field.name] : error;
  const getHelperText = isFormControlled ? currentError : helperText;
  const Component = getComponent({ dateWithoutKeyboard, isDateTime });

  return (
    <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
      <div className={`${classes.root} ${classes.popoverRoot}`}>
        <Component
          allowKeyboardControl
          clearable
          format={format || translate('date:DateFormat')}
          disableFuture={dateFuture}
          disablePast={!dateFuture}
          name={field?.name}
          value={isFormControlled ? field.value : value}
          helperText={getHelperText}
          error={Boolean(currentError)}
          onChange={(date, keyboardInputValue) => (isFormControlled
            ? form.setFieldValue(field.name, date, true)
            : onChange(date, keyboardInputValue))}
          autoOk
          PopoverProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
          }}
          {...other}
        />
      </div>
    </MuiPickersUtilsProvider>
  );
};

PF2MDatepickerNew.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
  classes: PropTypes.object.isRequired,
};

PF2MDatepickerNew.defaultProps = {
  field: {},
  form: {},
};

export default withStyles(styles)(PF2MDatepickerNew);
